import { gql } from '@apollo/client';

export const ALL_SCHOOL_TYPES = gql`
  query AllSchoolTypes {
    schoolTypes: getSchoolTypes {
      id
      name
    }
  }
`;
